import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import Monitor from './pages/Monitor';
import Historial from './pages/Historial';
import Gestion from './pages/Gestion';
import Alertas from './pages/Alertas';
import Uptime from './pages/Uptime';
import Diagnostico from './pages/Diagnostico';
import AdminUsuarios from './pages/AdminUsuarios';
import Login from './pages/Login';
import './App.css';

function App() {
  const [usuario, setUsuario] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('mueve_user');
    if (saved) { try { setUsuario(JSON.parse(saved)); } catch(e) {} }
    setChecking(false);
  }, []);

  const handleLogin = (user) => setUsuario(user);

  const handleLogout = () => {
    localStorage.removeItem('mueve_user');
    setUsuario(null);
  };

  if (checking) return null;
  if (!usuario) return <Login onLogin={handleLogin} />;

  const esAdmin = usuario.rol === 'admin';
  const esOperador = usuario.rol === 'admin' || usuario.rol === 'operador';

  return (
    <Router>
      <div className="app">
        <Navbar usuario={usuario} onLogout={handleLogout} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/monitor" element={<Monitor usuario={usuario} />} />
            <Route path="/historial" element={<Historial />} />
            <Route path="/gestion" element={esOperador ? <Gestion /> : <Navigate to="/" />} />
            <Route path="/alertas" element={<Alertas />} />
            <Route path="/uptime" element={<Uptime />} />
            <Route path="/diagnostico" element={<Diagnostico />} />
            <Route path="/usuarios" element={esAdmin ? <AdminUsuarios usuario={usuario} /> : <Navigate to="/" />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
